import { FaAward } from "react-icons/fa";
import { TbBooks } from "react-icons/tb";
import { BiHappyHeartEyes } from "react-icons/bi";

const data = [
  {
    id: 1,
    icon: <FaAward />,
    title: "View Experience",
    desc: "2 Years Working",
    type: "popup",
  },
  {
    id: 2,
    icon: <TbBooks />,
    title: "Projects",
    desc: "11 projects completed",
  },
  {
    id: 3,
    icon: <BiHappyHeartEyes />,
    title: "Clients",
    desc: "4 happy clients",
  },
];

export default data;
